// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XYgW","delete":"styles_delete__3E2fw","update":"styles_update__2kDqA","add":"styles_add__2aW88"};